import request from '@/utils/vip_request'
// 轮播图
export function get_imgs(params) {
  return request({
    url: '/home/vip/promotion',
    method: 'GET',
    params
  })
}
// 列表
// /vip/vip/getLessonListByCategory
export function get_list(params) {
  return request({
    url: '/home/vip/category',
    method: 'GET',
    params
  })
}
// 直播列表
export function get_liveList(params) {
  return request({
    url: '/home/vip/live',
    method: 'GET',
    params
  })
}
